module.exports = __webpack_public_path__ + "img/box-bg.8a0f20d5.jpg";